
import { mapActions, mapGetters, useStore } from "vuex";
import { ACTIONS, GETTERS, MUTATIONS, PAYDOWN_METHODS } from "../data";
import AccountSidebar from "../components/AccountSidebar.vue";
import ReactiveChart from "../components/ReactiveChart.vue";
import PaydownStats from "../components/PaydownStats/PaydownStats.vue";
import { plotlyConfig, CreateTrace } from "../data";
import { getTotalPaymentData } from "../assets/js/paydownData";
import { computed, defineComponent, onMounted, reactive, watch } from "vue";
import { PaymentDetail, PayPeriodDetail, DebtAccount } from "../interfaces";
import { key } from "@/store";

export default defineComponent({
  name: "DashboardView",
  setup() {
    let store = useStore(key),
      chartConfig: any = reactive(plotlyConfig);

    // set vertical line x coordinates
    chartConfig.layout.shapes[0].x0 = new Date();
    chartConfig.layout.shapes[0].x1 = new Date();

    const accounts = computed(() => store.state.accounts);

    const user = computed(() => store.state.userProfile);

    const updateChart = (accounts: DebtAccount[]) => {
      let paymentData;
      if (accounts && accounts !== null && accounts.length > 0) {
        try {
          paymentData = getTotalPaymentData(accounts, PAYDOWN_METHODS.snowball);

          store.commit(MUTATIONS.setPaymentData, paymentData);

          let xTrace = paymentData.paymentArray.map((x: any) => x.date);
          let traces = [];

          for (let i = 0; i < accounts.length; i++) {
            traces.push(
              CreateTrace({
                y: paymentData.paymentArray.map(
                  (payPeriod: PayPeriodDetail) => {
                    let paymentInfo = payPeriod.payments.filter(
                      (payment: PaymentDetail) =>
                        payment.loanID === accounts[i].id
                    );
                    if (paymentInfo.length > 0) {
                      return paymentInfo[0].balance;
                    } else {
                      return null;
                    }
                  }
                ),
                x: xTrace,
                name: accounts[i].name
              })
            );
          }

          chartConfig.traces = traces;
          chartConfig.layout.datarevision = Date.now();
        } catch (err) {
          console.error("Error updating chart:", err);
        }
      }
    };

    onMounted(() => updateChart(store.getters[GETTERS.getAccounts]));

    const unwatch = watch(
      () => store.state.accounts,
      (newAccounts: DebtAccount[], oldAccounts: DebtAccount[]) => {
        updateChart(newAccounts);
      }
    );

    return {
      user,
      accounts,
      unwatch,
      chartConfig
    };
  },
  components: {
    AccountSidebar,
    ReactiveChart,
    PaydownStats
  },
  methods: {
    ...mapActions([ACTIONS.logout]),
    ...mapGetters([GETTERS.getAccounts])
  }
});
